import type { MechKey } from './keys';

export const uk: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Механіка · 2D',
  'panel.scene': 'Сцена',
  'panel.dims': 'Параметри',
  'panel.style': 'Зовнішній вигляд',
  'panel.action': 'Керування',
  'style.body': 'Тіло',
  'style.vector': 'Вектори',
  'style.ground': 'Поверхня',
  'style.forces': 'Показати сили',
  'style.trace': 'Показати слід',
  'style.labels': 'Мітки векторів',
  'hint.line1': 'Натисніть «Відтворити» для запуску · перетягуйте тіла для переміщення',
  'hint.line2': 'Пісочниця: виберіть фігуру, потім клікніть для розміщення',
  'scene.incline': 'Похила площина',
  'scene.projectile': 'Рух снаряда',
  'scene.pendulum': 'Маятник',
  'scene.springMass': 'Система пружина-маса',
  'scene.collisions': 'Зіткнення',
  'scene.atwood': 'Машина Атвуда',
  'scene.circular': 'Колоподібний рух',
  'scene.sandbox': 'Пісочниця',
  'dim.angle': 'кут (°)',
  'dim.friction': 'тертя',
  'dim.mass': 'маса',
  'dim.massA': 'маса A',
  'dim.massB': 'маса B',
  'dim.velocity': 'швидкість',
  'dim.angleLaunch': 'кут запуску (°)',
  'dim.gravity': 'гравітація',
  'dim.gravityX': 'гравітація x',
  'dim.gravityY': 'гравітація y',
  'dim.length': 'довжина',
  'dim.damping': 'загасання',
  'dim.spring': 'жорсткість',
  'dim.restitution': 'пружність',
  'dim.radius': 'радіус',
  'dim.speed': 'швидкість',
  'action.play': 'Відтворити',
  'action.pause': 'Пауза',
  'action.step': 'Крок',
  'action.reset': 'Скинути',
  'action.speed': 'Швидкість',
  'action.clear': 'Очистити',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Гравітація',
  'forceName.normal': 'Нормальна сила',
  'forceName.friction': 'Сила тертя',
  'forceName.tension': 'Натяг',
  'forceName.spring': 'Сила пружини',
  'forceName.applied': 'Прикладена сила',
  'forceName.air': 'Опір повітря',
  'palette.box': 'Куб',
  'palette.circle': "М'яч",
  'palette.ramp': 'Похил',
  'palette.ground': 'Поверхня',
  'palette.hint': 'Виберіть фігуру, потім клікніть на полотно для розміщення.',
  'panel.forces': 'Спостережувані сили',
  'forces.empty': 'Поки нема — запустіть сцену',
};
